{
  "files": "Archivos",
  "request": "Solicitudes",
  "all": "Todos",
  "admin": "Administrador",
  "buyer": "Comprador",
  "seller": "Vendedor",
  "loading": "Cargando PDF",
  "browse-files": "busca archivos",
  "drag-or-drop": "Arrastrar y soltar archivo aqui o",
  "documents": "Documentos",
  "modal-rename-title": "Renombrar",
  "modal-rename-subtitle": "Ingrese un nuevo nombre para el documento",
  "modal-rename-regex": "El nombre solo puede usar letras, números y guiones",
  "modal-rename-cancel": "Cancelar",
  "modal-delete-title-span": "eliminar",
  "success-updating": "Documento actualizado",
  "user": "Usuario",
  "modal-delete-required-doc-title-prefix": "Este documento ya está asociado a un archivo, ¿está seguro de que desea ",
  "modal-delete-required-doc-title-suffix": " de la lista de documentos requeridos?",
  "pending": "Pendiente",
  "done": "Hecho",
  "invalid": "Inválido",
  "status": "Estado",
  "payment": "Pago",
  "reference": "Referencia",
  "routing": "Enrutamiento",
  "settlement-agency": "agencia de liquidación",
  "unactive-link": "Este enlace de carga ya no está activo.",
  "check-with-agent": "Consulte con su agente de título para ver si",
  "theres-new-link": "hay un nuevo enlace disponible.",
  "any-question-or": "Cualquier duda o inquietud puede contactar con su agente",
  "agent-or": "agente o la agencia directamente.",
  "close-window": "Cerrar esta ventana",
  "you-can-check": "Puede consultar nuestro",
  "privacy-notice": "aviso de privacidad",
  "for-more-informtion": "para mas informacion.",
  "send-files": "Enviar Archivos",
  "all-documents-have-been": "Todos sus documentos han sido enviados. Toda su información y documentos están protegidos de forma segura y solo serán utilizados por nuestro agente de título asignado a su pedido.",
  "Thanks-for-trusting": "Gracias por confiar en nosotros",
  "link-copied": "Enlace copiado al portapapeles",
  "there-not-docs": "No hay documentos requeridos todavía",
  "are-you-sure": "¿Estás seguro de darse de baja?",
  "if-you-unsubscribe": "Si cancela su suscripción ahora, dejará de recibir las actualizaciones de su pedido y toda la información relacionada.",
  "subscribe-again": "Si desea suscribirse nuevamente, comuníquese con",
  "clsing-agent": "su agente de cierre.",
  "unsubscribed": "¡Anuló la suscripción con éxito!",
  "we-miss-you": "Ya te extrañamos. Gracias por ser parte de nuestro proyecto, esperamos verte pronto.",
  "yes-unsubscribe": "Si, cancelarme la suscripción",
  "document-templates": "Plantillas de Documentos",
  "select-template": "Selecciona una plantilla para editar",
  "list-templates": "Lista de plantillas",
  "field-info": "Informacion",
  "images": "Imagenes",
  "copy-text": "Click para Copiar Texto",
  "copy-image": "Click para Copiar Imagen",
  "template": "Plantilla",
  "tag-copied": "Etiqueta copiada",
  "image-copied": "Imagen copiada",
  "signatures": "Firmas",
  "define-dates": "Definir los plazos para subir archivos",
  "document-request-sended": "Las solicitudes de documentos se enviaron correctamente",
  "document-request-continue": "Continuar",
  "document-request-single-use": "Este enlace se puede usar una sola vez; si necesita otro, solicite uno nuevo.",
  "document-request-not-yet": "Este enlace de carga aún no está disponible.",
  "document-request-used": "Este enlace ya se usó o ha expirado. Solicite uno nuevo.",
  "document-request-invalid": "Este enlace no es válido o ha expirado.",
  "document-request-expired": "Esta sesión de carga ha expirado. Solicite un nuevo enlace.",
  "send-doc": "Enviar documento para firmar",
  "archive": "Archivo",
  "upload-required-documents": "Carga de documentos requeridos",
  "provide-following-documents": "Por favor, proporcione los siguientes documentos enumerados aquí para continuar con el proceso.",
  "drag-drop-select": "Arrastre y suelte algunos archivos aquí, o haga clic aquí para seleccionar archivos",
  "error-uplading": "Se produjo un error inesperado al intentar cargar los archivos.",
  "upload-success": "Todos los documentos se cargaron exitosamente",
  "document-ron": "Documento para RON",
  "edit-document": "Editar Documento",
  "new-template": "Agregar una Plantilla",
  "back-to-templates": "Volver a las plantillas",
  "templates-empty": "Aún no hay plantillas de documentos.",
  "templates-error": "No se pudieron cargar las plantillas de documentos.",
  "template-options-loading": "Cargando opciones de plantilla...",
  "template-options-error": "No se pudieron cargar las opciones de plantilla.",
  "delete-template": "Eliminar plantilla",
  "narrow-results": "Mostrando las primeras {{count}} coincidencias. Escribe más para reducir la lista.",
  "property-required": "La propiedad es requerida",
  "code-required": "El codigo es requerido",
  "code-repeated": "El codigo ya existe",
  "kind-tem": "Tipo de Plantilla",
  "code": "Código",
  "deliver": "Repartidor",
  "party": "Partida",
  "property": "Propiedad",
  "signer": "Firmante",
  "name": "Nombre",
  "per": "Por",
  "transaction-type": "Tipo de Transacción",
  "type": "Tipo",
  "workflow": "Flujo de Trabajo",
  "send": "Enviar",
  "title-delete-template": "¿Estás seguro de eliminar la plantilla?",
  "description-delete-template": " Esta acción eliminará permanentemente la plantilla y no se podrá recuperar. ¿Estás seguro de que deseas continuar?",
  "confirm-delete": "Sí, eliminar plantilla",
  "deny-delete": "No, mantener plantilla ",
  "search-documents": "Buscar Documentos",
  "select-party": "Seleccionar una parte",
  "select-property": "Seleccionar una propiedad",
  "add-doc": "Agregar Documentos",
  "select-doc": "Seleccionar todos los Documentos",
  "description": "Descripción",
  "actions": "Acciones",
  "upload": "Subir",
  "data": "información",
  "document-download-success":"Documento descargado exitosamente.",
  "error-downloading": "Se produjo un error al descargar el archivo, inténtelo nuevamente.",
  "lack-of-email":"Tenemos un error, uno de los usuarios no tiene un email válido, por favor agrega uno nuevo",
  "date": "Fecha",
  "signature-from": "Firma de",
  "notes": "Notas",
  "options": "Opciones",
  "status-pending": "Pendiente",
  "status-complete": "Completo",
  "status-declined": "Rechazado",
  "status-has-error": "Error",
  "kind": "Tipo",
  "add-document": "Agregar Documento",
  "tutorial": "Tutorial",
  "request-file": "Solicitar Archivo",
  "documents-updating-message": "Los documentos se están actualizando, espere unos minutos y actualice los documentos",
  "delete-document": "Eliminar Documento",
  "delete-file": "Eliminar Archivo",
  "lock": "Bloquear",
  "unlock": "Desbloquear",
  "lock-document": "Bloquear Documento",
  "unlock-document": "Desbloquear Documento",
  "available-files": "Archivos disponibles",
  "included": "Incluido",
  "filter-by": "Filtrar por",
  "zip-content": "Contenido Zip",
  "pdf-content": "Contenido PDF",
  "available-properties": "Propiedades Disponibles",
  "properties-in-document": "Propiedades en el Documento",
  "available-parties": "Partes Disponibles",
  "deliver-to": "Entregar a",
  "parties-in-document": "Partes en el Documento",
  "document-signers": "Firmantes del Documento",
  "edit-content": "Editar contenido",
  "requestFileUploadTitle": "Solicitar Carga de Archivo",
  "selectTheParty": "Seleccionar la parte",
  "selectTheFiles": "Seleccionar los archivos",
  "sendRequest": "Enviar solicitud",
  "includedParts": "Partes incluidas",
  "pendingToUpload": "Pendiente de subir",
  "fileUploadInProgress": "Carga de Archivo en Progreso",
  "fileUploadMessage": "Su archivo se está cargando y se procesará en segundo plano. Aparecerá en el sistema una vez que se complete el procesamiento.",
  "ron": "(RON)",
  "lastUpdate": "Última actualización",
  "size": "Tamaño",
  "viewFile": "Ver archivo",
  "download": "Descargar",
  "editTemplateData": "Editar datos de plantilla",
  "requestSignature": "Solicitar firma",
  "editArchive": "Editar Archivo",
  "parties": "Partes",
  "expectedFrom": "Esperado de",
  "deleteDocument": "Eliminar documento",
  "editDocument": "Editar documento",
  "reloadPageMessage": "Por favor, recargue la página en un momento para ver los archivos cargados.",
  "createFilePer": "Crear archivo por",
  "createDocument": "Crear Documento",
  "createNewDocument": "Crear Nuevo Documento",
  "updateArchive": "Actualizar Archivo",
  "templateData": "Datos de Plantilla",
  "uploadPartyFiles": "Subir Archivos de Parte",
  "uploads": "Cargas",
  "pdf": "PDF",
  "zip": "ZIP",
  "calcSpreadsheet": "Hoja de cálculo Calc",
  "drawDrawing": "Dibujo Draw",
  "impressPresentation": "Presentación Impress",
  "writerDocument": "Documento Writer",
  "add-party": "Agregar Parte",
  "not-modified": "No modificado",
  "upload-files-tooltip": "Subir archivos",
  "add-parties-first-tooltip": "Antes de subir archivos, primero debe agregar las partes esperadas",
  "file-locked-tooltip": "Este archivo no se regenerará automáticamente cuando cambie la información.",
  "file-unlocked-tooltip": "Este archivo se regenerará automáticamente cuando cambie la información.",
  "filterBy": "Filtrar por"
}
